module.exports = __webpack_public_path__ + "files/4b3d278d1c57e097213140dea720119b.png";